import request from "@/utils/request";

export function getStoreRedpackList(params) {
  return request({
    url: "/product/store-red-packet/list",
    method: "get",
    params,
  });
}
export function addStoreRedpack(data) {
  return request({
    url: "/product/store-red-packet/add",
    method: "post",
    data,
  });
}

export function assignStoreRedpack(data) {
  return request({
    url: "/product/store-red-packet/claim-assign",
    method: "post",
    data,
  });
}
